<script>
import axios from 'axios';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

import FileUpload from '../FileUpload.vue';

export default {
	setup() {
		return { v$: useVuelidate() };
	},
	components: {
		FileUpload,
	},
	props: {
		idFromUrl: {
			type: String,
			default: null,
		},
		defaultError: {
			type: String,
			default: 'Vul dit veld in.',
		},
		errorIndicator: {
			type: String,
			default: 'Deze verplichte velden moeten worden ingevuld',
		},
		acceptedFileTypes: {
            type: String,
            default: '.pdf,.doc,.docx,.gdoc,.xls,.xlsx,.csv,.jpg,.jpeg,.tif,.tiff',
		},
		maxSize: {
            type: Number,
            default: 200,
        }
	},
	data() {
		return {
			claimDetailsData: {},
			externalrequestreasonchoice: 'ChoiceAanvullenStukkenDocumenten',
			subjectinput: '',
			descriptioninput: '',
			emailconfirmation: false,
			addattachment: false,
			uploadFiles: [],
			fileIDs: [],
			noteSuccess: false,
		};
	},
	validations() {
		return {
			externalrequestreasonchoice: { required },
			subjectinput: { required },
			descriptioninput: { required },
		};
	},
	async mounted() {
		await this.fetchData(this.idFromUrl);
	},
	methods: {
		async fetchData(idFromURL) {
			try {
				const response = await axios.get(
					`/api/dossiers/${idFromURL}/vorderinggegevens`
				);
				if (response ?? response.data) {
					this.claimDetailsData = response.data;
				} else {
					console.error('Invalid data received:', response);
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		},
		async submitNote() {
			const result = await this.v$.$validate();
			this.fileIDs = this.$refs.fileUploadMultiple.fileIDs;
			this.uploadFiles = this.$refs.fileUploadMultiple.processedFiles;
			if (this.fileIDs.length) this.addattachment = true;
			if (result) {
				const noteResponse = await axios.post(
					`/api/dossiers/${this.idFromUrl}/notes`,
					{
						UwReferentie: this.claimDetailsData.referentie_nr,
						ExternalRequestReasonChoice: this.externalrequestreasonchoice,
						SubjectInput: this.subjectinput,
						DescriptionInput: this.descriptioninput,
						EmailConfirmation: this.emailconfirmation,
						AddAttachment: this.addattachment,
						FileIDs: this.fileIDs,
					}
				);
				if (noteResponse.status === 200) this.noteSuccess = true;
			}
		},
        onReload() {
            window.location.reload();
        },
	},
};
</script>

<template>
	<template v-if="noteSuccess">
		<div class="content">
			<p>{{ $store.getters.getLeftText('dossierdetailNoteSuccess') }}</p>
		</div>
		<hr />
		<div class="is-flex is-justify-content-flex-end">
			<button class="button is-primary is-size-9" @click="onReload">
				{{ $store.getters.getLeftText('dossierdetailButtonEnd') }}
			</button>
		</div>
	</template>
	<template v-else>
		<form ref="notesForm" novalidate>
			<div class="form-error has-text-danger" v-if="v$.$error">
				{{ errorIndicator }}
			</div>
			<div class="field mb-4">
				<label class="label" for="externalrequestreasonchoice"><span class="has-text-danger">*</span> {{ $store.getters.getLeftText('dossierdetailLabelChooseReason') }}</label>
				<div class="control is-expanded">
					<div class="select is-fullwidth">
						<select
							id="externalrequestreasonchoice"
							name="externalrequestreasonchoice"
							v-model="externalrequestreasonchoice"
							required>
							<option value="ChoiceAanvullenStukkenDocumenten">
								{{
									$store.getters.getLeftText(
										'dossierdetailOptionAdditionalPiecesDocuments'
									)
								}}
							</option>
							<option value="ChoiceIndienenklacht">
								{{
									$store.getters.getLeftText(
										'dossierdetailOptionSubmitComplaint'
									)
								}}
							</option>
							<option value="ChoiceReactieBezwaar">
								{{
									$store.getters.getLeftText(
										'dossierdetailOptionObjectionResponse'
									)
								}}
							</option>
							<option value="ChoiceReactieOntvangenKlacht">
								{{
									$store.getters.getLeftText(
										'dossierdetailOptionResponseReceivedComplaint'
									)
								}}
							</option>
							<option value="ChoiceReactieRegelingsvoorstel">
								{{
									$store.getters.getLeftText(
										'dossierdetailOptionResponseSchemeProposal'
									)
								}}
							</option>
							<option value="ChoiceVerzoekopgavestandvanzaken">
								{{
									$store.getters.getLeftText(
										'dossierdetailOptionRequestStateOfAffairs'
									)
								}}
							</option>
							<option value="ChoiceVerzoeksluiten">
								{{
									$store.getters.getLeftText('dossierdetailOptionCloseRequest')
								}}
							</option>
							<option value="ChoiceOverigevraagopmerking">
								{{
									$store.getters.getLeftText(
										'dossierdetailOptionAnotherQuestion'
									)
								}}
							</option>
						</select>
					</div>
				</div>
				<span v-if="v$.externalrequestreasonchoice.$error" class="has-text-danger form-error" >{{ defaultError }}</span >
			</div>

			<div class="field">
				<label class="label" for="subjectinput" ><span class="has-text-danger">*</span> {{ $store.getters.getLeftText('dossierdetailLabelSubject') }}</label>
				<div class="control">
					<input
						id="subjectinput"
						class="input"
						type="text"
						name="subjectinput"
						required
						v-model="subjectinput">
				</div>
				<span v-if="v$.subjectinput.$error" class="has-text-danger form-error">{{ defaultError }}</span>
			</div>

			<div class="field">
				<label class="label" for="descriptioninput"><span class="has-text-danger">*</span> {{ $store.getters.getLeftText('dossierdetailLabelDescription') }}</label>
				<div class="control">
					<textarea
						id="descriptioninput"
						class="input"
						type="text"
						name="descriptioninput"
						required
						v-model="descriptioninput"></textarea>
				</div>
				<span v-if="v$.descriptioninput.$error" class="has-text-danger form-error">{{ defaultError }}</span>
			</div>

			<div class="field">
				<div class="control">
					<input
						name="checkbox"
						type="checkbox"
						id="checkbox-kopie"
						class="by-checkbox"
						v-model="emailconfirmation">
					<label for="checkbox-kopie" class="by-checkable is-size-9">{{ $store.getters.getLeftText('dossierdetailLabelEmailConfirmation') }}</label>
				</div>
			</div>
			<file-upload
				api-url="/api/account/tempfiles"
				:multiple="true"
				:required="false"
				:two-column="false"
				label="Bewijsstukken bijvoegen"
				:accept="acceptedFileTypes"
				upload-text="Bestanden uploaden"
				drop-text="Of bestanden plaatsen"
				modal-title="Bestanden uploaden"
				button-text="Gereed"
				file-of="van"
				file-upload-single="bestand geüpload"
				file-upload-plural="bestanden geüpload"
                :max-size="maxSize"
                failed="upload mislukt"
                too-big="bestand is te groot"
				remove="verwijder"
				required-error-text="kies een bestand"
				error-text="Je kunt alleen de volgende bestandstypen uploaden:"
				ref="fileUploadMultiple"
			></file-upload>

			<hr>

			<div class="is-flex is-justify-content-flex-end">
				<button type="submit" class="button is-primary is-size-9" @click.prevent="submitNote">
					{{ $store.getters.getLeftText('dossierdetailButtonCreateNote') }}
				</button>
			</div>
		</form>
	</template>
</template>
